export default __webpack_public_path__ + "static/media/manage-modifiers-hover.a659b335.svg";